import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/rectangle creams/rectangle pineapple biscuit.png";
import BiscuitImg from "../../../assets/products/rectangle creams/Rectangle-Pineapple.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 27,
  },
  {
    grams: 40,
  },
  {
    grams: 50,
  },
  {
    grams: 75,
  },
  {
    grams: 80,
  },
];

export default function PineappleRectangleProduct() {
  return (
    <>
      <Helmet>
        <title>
          Rectangle Pineapple Cream Biscuit – BearBitz | Premium Biscuits &
          Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Rectangle Pineapple Cream Biscuits — tangy pineapple-flavored sandwich biscuits with smooth cream filling. View pack sizes, cartons, and global specs."
        />
        <meta
          name="keywords"
          content="Rectangle Pineapple Cream Biscuit, BearBitz Pineapple Cream Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/rectangle-cream-biscuit/rectangle-pineapple"
        />
        <meta
          property="og:title"
          content="Rectangle Pineapple Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Tangy pineapple-flavored cream biscuits with export-ready packaging and premium quality."
        />
      </Helmet>

      <ProductTemplate
        productTitle="PINEAPPLE"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in every shape and flavor. A global snack sensation that delights with every bite."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#629C14"
        sectionBgColor="#E6FFC6"
        productBgcolor="#C5FC7C"
        tableheadBgcolor="#629C14"
        tableBgcolor="#FBFFF6"
        footerBgcolor="#629C14"
      />
    </>
  );
}
